import Divider from "@components/general/Divider";
import Panel from "@components/general/Panel";
import Translate from "@service/Translate";
import { FC, Fragment, useContext } from "react";
import { ParticipateContext } from "./Context";
import { FeedbackSharingItem } from "./FeedbackSharingItem";

export const FeedbackSharing: FC = () => {
    const { tr } = Translate;
    const { participate } = useContext(ParticipateContext);

    return (
        participate.fellowTravelers?.length ?
            <div id="feedBackSharing" className="feedback-sharing">
                <Panel>
                    <header className="feedback-sharing-header">{tr("feedback_sharing_companions_title")}</header>
                    <main className="feedback-sharing-companions">
                        {
                            participate.fellowTravelers?.map((traveler, index) =>
                                <Fragment key={index}>
                                    <FeedbackSharingItem traveler={traveler} />
                                    {index < (participate.fellowTravelers?.length as number) - 1 && <Divider mode="perforation" orientation="horizontal" />}
                                </Fragment>
                            )
                        }
                    </main>
                </Panel>
            </div>
            : null
    )
}